import { render, staticRenderFns } from "./CardsCategoria.vue?vue&type=template&id=761a5eac&"
import script from "./CardsCategoria.vue?vue&type=script&lang=ts&"
export * from "./CardsCategoria.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('761a5eac', component.options)
    } else {
      api.reload('761a5eac', component.options)
    }
    module.hot.accept("./CardsCategoria.vue?vue&type=template&id=761a5eac&", function () {
      api.rerender('761a5eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Capacitaciones/CardsCategoria.vue"
export default component.exports